import api from '../../api/_dossier-medical'


const state = () => ({
    state: {
        antecedentsPerso: null,

        // Allergo personnel
        antecedent_allergo_personnel: [],
        antecedent_allergo_personnel_historique: [],

        // Allergo familiaux
        antecedent_allergo_familiaux: [],
        antecedent_allergo_familiaux_historique: [],

        // Allergo Environnement de vie
        antecedent_allergo_environnement: [],
        antecedent_allergo_environnement_historique: [],

        // Pediatrie personnel
        antecedent_enf_personnel: [],
        antecedent_enf_personnel_historique: [],

        // Pediatrie familiaux
        antecedent_enf_familiaux: [],
        antecedent_enf_familiaux_historique: [],

        // Néonatologie - Géniteur
        antecedent_neonatologie: [],
        antecedent_neonatologie_historique: [],

        // Néonatologie - Nouveau né
        antecedent_neonatologie_nouveaune: [],
        antecedent_neonatologie_nouveaune_historique: [],

        // Adulte Personnel
        antecedent_adulte_personnel: [],
        antecedent_adulte_personnel_historique: [],

        // Adulte Familiaux
        antecedent_adulte_familiaux: [],
        antecedent_adulte_familiaux_historique: [],

        // Histoire de la maladie - Anamnèse
        histoire_anamnese: [],
        histoire_anamnese_historique: []
    }
  
})

// getters
const getters = {
    antecedentsPerso: (state) =>{
        return state.antecedentsPerso
    },
    
    antecedent_allergo_personnel: (state) =>{
        return state.antecedent_allergo_personnel
    },

    antecedent_allergo_personnel_historique: (state) =>{
        return state.antecedent_allergo_personnel_historique
    },

    antecedent_allergo_familiaux: (state) =>{
        return state.antecedent_allergo_familiaux
    },

    antecedent_allergo_familiaux_historique: (state) =>{
        return state.antecedent_allergo_familiaux_historique
    },

    antecedent_allergo_environnement: (state) =>{
        return state.antecedent_allergo_environnement
    },

    antecedent_allergo_environnement_historique: (state) =>{
        return state.antecedent_allergo_environnement_historique
    },

    // Pediatrie
    antecedent_enf_personnel: (state) =>{
        return state.antecedent_enf_personnel
    },

    antecedent_enf_personnel_historique: (state) =>{
        return state.antecedent_enf_personnel_historique
    },

    antecedent_enf_familiaux: (state) =>{
        return state.antecedent_enf_familiaux
    },

    antecedent_enf_familiaux_historique: (state) =>{
        return state.antecedent_enf_familiaux_historique
    },

    antecedent_neonatologie: (state) =>{
        return state.antecedent_neonatologie
    },

    antecedent_neonatologie_historique: (state) =>{
        return state.antecedent_neonatologie_historique
    },

    // Adulte
    antecedent_adulte_personnel: (state) =>{
        return state.antecedent_adulte_personnel
    },

    antecedent_adulte_personnel_historique: (state) =>{
        return state.antecedent_adulte_personnel_historique
    },

    antecedent_adulte_familiaux: (state) =>{
        return state.antecedent_adulte_familiaux
    },

    antecedent_adulte_familiaux_historique: (state) =>{
        return state.antecedent_adulte_familiaux_historique
    },

    histoire_anamnese: (state) =>{
        return state.histoire_anamnese
    },

    histoire_anamnese_historique: (state) =>{
        return state.histoire_anamnese_historique
    },
}

// mutations
const mutations = {
    SET_ANTECEDENTS_PERSO(state,antecedentsPerso){
        state.antecedentsPerso = antecedentsPerso
    },
    
    ADD_MALADIE_TO_LIST(state,maladie){
        state.antecedentsPerso.maladies.push(maladie)
    },

    ADD_AFFECTIONS_TO_LIST(state,affection){
        state.antecedentsPerso.affections_congenitales.push(affection)
    },

    ADD_INTERVENTION_CHIRURGICALE_TO_LIST(state,intervention){
        state.antecedentsPerso.interventions_chirurgicales.push(intervention)
    },

    ADD_SEJOUR_ETRANGER(state,sejour){
        state.antecedentsPerso.sejours_etrangers.push(sejour)
    }, 

    SET_ANTECEDENT_ALLERGO_PERSONNEL(state, antecedents){
        state.antecedent_allergo_personnel = antecedents
    }, 

    SET_HISTORIQUE_ANTECEDENT_ALLERGO_PERSONNEL(state, antecedents){
        state.antecedent_allergo_personnel_historique = antecedents
    },
    
    SET_ANTECEDENT_ALLERGO_FAMILIAUX(state, antecedents){
        state.antecedent_allergo_familiaux = antecedents
    }, 

    SET_HISTORIQUE_ANTECEDENT_ALLERGO_FAMILIAUX(state, antecedents){
        state.antecedent_allergo_familiaux_historique = antecedents
    },

    SET_ANTECEDENT_ALLERGO_ENVIRONNEMENT(state, antecedents){
        state.antecedent_allergo_environnement = antecedents
    }, 

    SET_HISTORIQUE_ANTECEDENT_ALLERGO_ENVIRONNEMENT(state, antecedents){
        state.antecedent_allergo_environnement_historique = antecedents
    },

    // Pediatrie
    SET_ANTECEDENT_ENF_PERSONNEL(state, antecedents){
        state.antecedent_enf_personnel = antecedents
    }, 

    SET_HISTORIQUE_ANTECEDENT_ENF_PERSONNEL(state, antecedents){
        state.antecedent_enf_personnel_historique = antecedents
    },

    SET_ANTECEDENT_ENF_FAMILIAUX(state, antecedents){
        state.antecedent_enf_familiaux = antecedents
    }, 

    SET_HISTORIQUE_ANTECEDENT_ENF_FAMILIAUX(state, antecedents){
        state.antecedent_enf_familiaux_historique = antecedents
    },

    SET_ANTECEDENT_NEONATOLOGIE(state, antecedents){
        state.antecedent_neonatologie = antecedents
    }, 

    SET_HISTORIQUE_ANTECEDENT_NEONATOLOGIE(state, antecedents){
        state.antecedent_neonatologie_historique = antecedents
    },

    SET_ANTECEDENT_ADULTE_PERSONNEL(state, antecedents){
        state.antecedent_adulte_personnel = antecedents
    }, 

    SET_HISTORIQUE_ANTECEDENT_ADULTE_PERSONNEL(state, antecedents){
        state.antecedent_adulte_personnel_historique = antecedents
    },

    SET_ANTECEDENT_ADULTE_FAMILIAUX(state, antecedents){
        state.antecedent_adulte_familiaux = antecedents
    }, 

    SET_HISTORIQUE_ANTECEDENT_ADULTE_FAMILIAUX(state, antecedents){
        state.antecedent_adulte_familiaux_historique = antecedents
    },

    SET_HISTOIRE_DE_LA_MALADIE(state, histoire){
        state.histoire_anamnese = histoire
    },

    SET_HISTOIRE_DE_LA_MALADIE_HISTORIQUE(state, histoire){
        state.histoire_anamnese_historique = histoire
    },
}

// actions
const actions = {
    getPatientAntecedentsPerso({commit},patientId){
        return new Promise((resolve,reject) =>{
            api.getPatientAntecedentPerso(patientId).then(
                response =>{
                    resolve(response)
                    response.affections_congenitales = JSON.parse(response.affections_congenitales)
                    response.maladies = JSON.parse(response.maladies)
                    response.sejours_etrangers = JSON.parse(response.sejours_etrangers)
                    response.interventions_chirurgicales = JSON.parse(response.interventions_chirurgicales)
                    commit('SET_ANTECEDENTS_PERSO',response)
                }, error =>{
                    reject(error)
                }
            )
        })
    },

    saveAntecedentsPerso({commit},{data,patientId}){
        return new Promise((resolve,reject) =>{
            api.saveAntecedentsPerso(data,patientId).then(
                response =>{
                    resolve(response),
                    commit('SET_ANTECEDENTS_PERSO',response)
                },error =>{
                    reject(error)
                }
            )        
        })
    },


    getConsultationAntecedent({ commit }, data ) {
        return new Promise((resolve, reject) => {
            api.getConsultationAntecedent(data).then(
                response => {
                    if (data.est_en_cours == true) {
                        if (data.data_type == 'antecedent_allergologie_personnel') {
                            commit('SET_ANTECEDENT_ALLERGO_PERSONNEL', response)
                            resolve(response)
                        } else if (data.data_type == 'antecedent_allergologie_familiaux') {
                            commit('SET_ANTECEDENT_ALLERGO_FAMILIAUX', response)
                            resolve(response)
                        } else if (data.data_type == 'antecedent_allergologie_environnement') {
                            commit('SET_ANTECEDENT_ALLERGO_ENVIRONNEMENT', response)
                            resolve(response)
                        } else if (data.data_type == 'antecedent_enf_personnel') {
                            commit('SET_ANTECEDENT_ENF_PERSONNEL', response)
                            resolve(response)
                        } else if (data.data_type == 'antecedent_enf_familiaux') {
                            commit('SET_ANTECEDENT_ENF_FAMILIAUX', response)
                            resolve(response)
                        } else if (data.data_type == 'antecedent_neonatologie') {
                            commit('SET_ANTECEDENT_NEONATOLOGIE', response)
                            resolve(response)
                        } else if (data.data_type == 'antecedent_adulte_personnel') {
                            commit('SET_ANTECEDENT_ADULTE_PERSONNEL', response)
                            resolve(response)
                        } else if (data.data_type == 'antecedent_adulte_familiaux') {
                            commit('SET_ANTECEDENT_ADULTE_FAMILIAUX', response)
                            resolve(response)
                        } else if (data.data_type == 'histoire_de_la_maladie') {
                            commit('SET_HISTOIRE_DE_LA_MALADIE', response)
                            resolve(response)
                        }
                    } else {
                        if (data.data_type == 'antecedent_allergologie_personnel') { 
                            commit('SET_HISTORIQUE_ANTECEDENT_ALLERGO_PERSONNEL', response)
                            resolve(response)
                        } else if (data.data_type == 'antecedent_allergologie_familiaux') { 
                            commit('SET_HISTORIQUE_ANTECEDENT_ALLERGO_FAMILIAUX', response)
                            resolve(response)
                        } else if (data.data_type == 'antecedent_allergologie_environnement') { 
                            commit('SET_HISTORIQUE_ANTECEDENT_ALLERGO_ENVIRONNEMENT', response)
                            resolve(response)
                        } else if (data.data_type == 'antecedent_enf_personnel') { 
                            commit('SET_HISTORIQUE_ANTECEDENT_ENF_PERSONNEL', response)
                            resolve(response)
                        } else if (data.data_type == 'antecedent_enf_familiaux') { 
                            commit('SET_HISTORIQUE_ANTECEDENT_ENF_FAMILIAUX', response)
                            resolve(response)
                        } else if (data.data_type == 'antecedent_neonatologie') { 
                            commit('SET_HISTORIQUE_ANTECEDENT_NEONATOLOGIE', response)
                            resolve(response)
                        } else if (data.data_type == 'antecedent_adulte_personnel') { 
                            commit('SET_HISTORIQUE_ANTECEDENT_ADULTE_PERSONNEL', response)
                            resolve(response)
                        } else if (data.data_type == 'antecedent_adulte_familiaux') { 
                            commit('SET_HISTORIQUE_ANTECEDENT_ADULTE_FAMILIAUX', response)
                            resolve(response)
                        } else if (data.data_type == 'histoire_de_la_maladie') { 
                            commit('SET_HISTOIRE_DE_LA_MALADIE_HISTORIQUE', response)
                            resolve(response)
                        }
                    }
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getPatientAntecedent({ commit }, data ) {
        return new Promise((resolve, reject) => {
            api.getPatientAntecedent(data).then(
                response => {
                    if (data.est_en_cours == true) {
                        if (data.data_type == 'antecedent_adulte_personnel') {
                            commit('SET_ANTECEDENT_ADULTE_PERSONNEL', response)
                            resolve(response)
                        } else if (data.data_type == 'antecedent_adulte_familiaux') {
                            commit('SET_ANTECEDENT_ADULTE_FAMILIAUX', response)
                            resolve(response)
                        }
                    } else {
                        if (data.data_type == 'antecedent_adulte_personnel') { 
                            commit('SET_HISTORIQUE_ANTECEDENT_ADULTE_PERSONNEL', response)
                            resolve(response)
                        } else if (data.data_type == 'antecedent_adulte_familiaux') { 
                            commit('SET_HISTORIQUE_ANTECEDENT_ADULTE_FAMILIAUX', response)
                            resolve(response)
                        }
                    }
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveConsultationAntecedent({dispatch}, data){
        return new Promise((resolve,reject) =>{
            api.saveConsultationAntecedent(data).then(
                response =>{
                    dispatch
                    resolve(response)
                },error =>{
                    reject(error)
                }
            )        
        })
    },

    /**
     * Sauvegarder les antécédents (permanents) d'un patient
     * @param {*} param0 
     * @param {*} data 
     * @returns 
     */
    savePatientAntecedent({dispatch}, data){
        return new Promise((resolve,reject) =>{
            api.savePatientAntecedent(data).then(
                response =>{
                    resolve(response),
                    dispatch('getConsultationAntecedent', 
                        {
                            consultation_id: data.consultation_id, 
                            data_type: data.data_type
                        }
                    )
                },error =>{
                    reject(error)
                }
            )        
        })
    },

    deleteAntecedent({dispatch}, data){
        return new Promise((resolve,reject) =>{
            api.deleteAntecedent(data).then(
                response =>{
                    resolve(response)
                    dispatch
                },error =>{
                    reject(error)
                }
            )        
        })
    },
}

export default {
  state,
  getters,
  actions,
  mutations
}
